module.exports = __webpack_public_path__ + "resources/img/server-console-and-compat.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/server-console-and-compat.png
// module id = 1275
// module chunks = 0